export const END_USER_LICENSE_AGREEMENT = 'END_USER_LICENSE_AGREEMENT';
export const UPDATE_NOTICES = 'UPDATE_NOTICES';
export const UPDATE_CONSENT = 'UPDATE_CONSENT';
export const SET_UPDATE_CONSENT = 'SET_UPDATE_CONSENT';
export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY';
export const SET_DOMAIN_PATH = 'SET_DOMAIN_PATH';
export const SET_POLICIES_ACCEPTED = 'SET_POLICIES_ACCEPTED';
